import React from "react"

import { Space, Switch } from "@atos6/ui"

type Props = {
  value: boolean
  onChange: (checked: boolean) => void
}

export const SwitchDonate = (props: Props) => (
  <Space>
    <Switch checked={props.value} onChange={props.onChange} />
    {props.value ? <LabelChecked /> : <LabelUnchecked />}
  </Space>
)

const LabelChecked = () => (
  <div className="text-blue-600">Doação online Ativada</div>
)

const LabelUnchecked = () => (
  <div className="text-gray-600">Doação online desativada</div>
)
